import {View} from 'MWC';
import tpl from '../templates/interactive.jsx';
import {apiback} from '../../../../config';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        return this;
    }

    changeFilesUrl(url) {
        if (url) {
            const file = 'file?';
            const img = 'img?';
            const sliceIndex = url.indexOf(img) !== -1 ? url.indexOf(img) : url.indexOf(file);
            return apiback('API_PAGES') + '/media/' + url.slice(sliceIndex);
        }
    }

    static contextTypes = {
        app: PropTypes.object
    };
}
